import React from 'react';

import styles from './messageFundModalStyles';

import Button, {
  BUTTON_SIZES,
  BUTTON_TYPES,
  BUTTON_WIDTHS
} from 'buyside/components/presentation/Button/button';
import ErrorMessage from 'buyside/components/presentation/ErrorMessage/errorMessage';
import Modal from 'buyside/components/presentation/Modal/modal';

import EnvelopeIcon from 'buyside/svgs/envelope.svg';

const MINIMUM_VIEW_COUNT = 3;

class MessageFundModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      status: 'unsent',
      message: `I work for ${props.allocatorName}. I saw your firm's materials on the Cap Intro platform and I'd like to start a dialogue. Please let me know when you're available to speak.`
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.generateModalTitle = this.generateModalTitle.bind(this);
    this.generateModalContent = this.generateModalContent.bind(this);
    this.showAutoPromptModal = this.showAutoPromptModal.bind(this);
  }

  handleChange(e) {
    this.setState({ message: e.target.value });
  }

  handleSubmit() {
    this.setState({ status: 'sending' });
    this.props.sendMessage(this.state.message).then(
      () => this.setState({ status: 'sent' }),
      () => this.setState({ status: 'error' })
    );
  }

  openModal() {
    this.setState({ modalOpen: true });
  }

  closeModal() {
    this.setState({ modalOpen: false });
  }

  componentDidMount() {
    if (this.showAutoPromptModal()) {
      setTimeout(() => {
        this.setState({ modalOpen: true });
      }, 5000);
    }
  }

  showAutoPromptModal() {
    if (this.props.viewCount === 0) {
      return false;
    }
    return this.props.viewCount % MINIMUM_VIEW_COUNT === 0;
  }

  generateModalContent() {
    if (this.showAutoPromptModal()) {
      return (
        <React.Fragment>
          <p>
            Cap Intro is a reverse solicitation platform, which means Allocator members have to
            initiate any conversations. We noticed you have visited this page before, so we would
            encourage you to begin a dialogue.
          </p>
          <p>
            <strong>Some sample starter text is below to get the conversation started:</strong>
          </p>
        </React.Fragment>
      );
    } else {
      return (
        <p>
          <strong>Please enter your message for {this.props.fundName}:</strong>
        </p>
      );
    }
  }

  generateModalTitle() {
    if (this.showAutoPromptModal() && this.state.status === 'unsent') {
      return `Interested in ${this.props.fundName}? Send a message`;
    } else {
      return this.state.status === 'sent' ? 'Message Sent' : `Message to ${this.props.fundName}`;
    }
  }

  renderOpenModalButton() {
    return (
      <Button
        className={styles.messageFundButton}
        icon={EnvelopeIcon}
        onClick={this.openModal}
        size={BUTTON_SIZES.LARGE}
        text="Message This Fund"
        type={BUTTON_TYPES.MAJOR}
        width={BUTTON_WIDTHS.FULL}
      />
    );
  }

  render() {
    const { status, message } = this.state;

    return (
      <Modal
        isOpen={this.state.modalOpen}
        onClose={this.closeModal}
        renderOpenModalButton={() => this.renderOpenModalButton()}
        title={this.generateModalTitle()}
      >
        {status === 'sent' && (
          <div>
            <div>Your message was sent successfully.</div>
            <div className={styles.messageFundModalButtons}>
              <Button text="OK" type={BUTTON_TYPES.PRIMARY} onClick={this.closeModal} />
            </div>
          </div>
        )}
        {status !== 'sent' && (
          <div>
            {status === 'error' && (
              <ErrorMessage title="Uh Oh...">
                There was a problem sending your message. Please refresh the page. If the problem
                persists contact <a href="mailto:support@sumzero.com">support@sumzero.com</a>.
              </ErrorMessage>
            )}
            <div>
              {this.generateModalContent()}
              <textarea
                name="message"
                className={`form-control ${styles.messageFundModalTextArea}`}
                value={message}
                onChange={this.handleChange}
              />
            </div>
            <div className={styles.messageFundModalButtons}>
              <Button
                text={status === 'sending' ? 'Sending...' : 'Send Message'}
                type={BUTTON_TYPES.PRIMARY}
                onClick={this.handleSubmit}
                isLoading={status === 'sending'}
              />
              <Button
                text="Cancel"
                type={BUTTON_TYPES.SECONDARY}
                onClick={this.closeModal}
                isLoading={status === 'sending'}
              />
            </div>
          </div>
        )}
      </Modal>
    );
  }
}

export default MessageFundModal;
